import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === "object" && error !== null && "status" in error;
}

function isSerializedError(error: unknown): error is SerializedError {
  return typeof error === "object" && error !== null && "message" in error;
}

export function getErrorMessage(error: unknown): string {
  // From chatgpt
  if (!error) return "Unknown error occurred.";

  if (isFetchBaseQueryError(error)) {
    if (
      typeof error.data === "object" &&
      error.data !== null &&
      ("message" in error.data || "error" in error.data)
    ) {
      const data = error.data as Record<string, any>;
      return data.message || data.error || JSON.stringify(data);
    }

    return `Request failed with status ${error.status}`;
  }

  if (isSerializedError(error)) {
    return error.message || "An unexpected error occurred.";
  }

  if (typeof error === "string") {
    return error;
  }

  return "An unexpected error occurred.";
}
